import { createGlobalStyle } from 'styled-components';
export const ToniesTypographyStyles = createGlobalStyle `
  b, strong {
    font-weight: 700;
  }

  i, em {
    font-style: italic;
  }

  code, pre {
    font-family: monospace;
  }
`;
